import styled from 'styled-components';

import {Button as MuiButton} from '@material-ui/core';

export const Button = styled(MuiButton).attrs((props) => ({size: props.size || 'small'}))``;
